'use client';

import { completeLotteryInvitation } from '@/api/activity';
import { useStore } from '@/providers/app-store-provider';
import logger from '@/utils/client-logger';
import { isInZeloolApp } from '@/utils/tools';
import { useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';

const SHARE_MEDIA = ['copy', 'Facebook', 'X', 'Messenger', 'WhatsApp'] as const;

/** 只处理当前 URL，不保存跨页邀请状态，也不改变现有登录流程。 */
export function useLotteryInviteInit() {
  const token = useStore((state) => state.token);
  const ready = useStore((state) => state.clientTokenReady);
  const search = useSearchParams().toString();
  const sessionRef = useRef({ token, attempted: new Set<string>() });

  useEffect(() => {
    // 认证切换后允许重新尝试；同一会话内保留失败记录，避免重渲染触发重试。
    if (sessionRef.current.token !== token) {
      sessionRef.current = { token, attempted: new Set<string>() };
    }
    const session = sessionRef.current;
    if (!ready || !token) return;
    const params = new URLSearchParams(search);
    // 等既有 OAuth 流程清理 token 回跳参数后再归因。
    if (params.has('token') && !isInZeloolApp()) return;
    const campaignId = Number(params.get('draw_campaign_id'));
    const inviteCode = params.get('draw_invite_code');
    if (
      !Number.isSafeInteger(campaignId) ||
      campaignId <= 0 ||
      !inviteCode?.trim() ||
      inviteCode.length > 64
    )
      return;
    const medium = SHARE_MEDIA.find((value) => value === params.get('utm_medium')) ?? null;
    const key = JSON.stringify([campaignId, inviteCode, medium]);
    // 包含 Strict Mode effect 重建；失败不随重渲染自动重试。
    if (session.attempted.has(key)) return;
    session.attempted.add(key);

    void completeLotteryInvitation({
      draw_campaign_id: campaignId,
      draw_invite_code: inviteCode,
      utm_medium: medium,
    }).catch(() => {
      logger.error('[lottery-tool] invite_complete_failed');
    });
  }, [search, token, ready]);
}
